export default __webpack_public_path__ + "static/media/icon-browse-circle-solid.8ae0085e.svg";